import { Component, Input, OnInit } from "@angular/core";
import { LatestProductFirmware } from "@app/products/products.models";

@Component({
	selector: "c4-product-firmware-item",
	templateUrl: "./product-firmware-item.component.html",
	styleUrls: ["./product-firmware-item.component.scss"]
})
export class ProductFirmwareItemComponent implements OnInit {
	@Input() firmware: LatestProductFirmware;

	showDetails: boolean;

	constructor() { }

	ngOnInit() {
	}

}
